package com.jingfangpai.api.base

import kotlinx.browser.sessionStorage

/**
 * 各端自定义的请求头部
 */
const val JWT_SESSIONSTORAGE_KEY = "jwt"
actual fun getHttpHeaders(): Array<Pair<String, String>> {
    return arrayOf("jwt" to (sessionStorage.getItem(JWT_SESSIONSTORAGE_KEY)?:""))
}